/** 
 * @file Improves user experience by alerting the user when their session is about to expire.
 */
import React from 'react';
import {Button, Paper} from '@material-ui/core';
import NotSignedIn from '../errors/NotSignedIn';
import {makeStyles} from '@material-ui/core/styles';
type Props = {
  signOut: () => void,
  isLoggedIn: boolean,
  secondsRemaining: number
}

const useStyles = makeStyles(() => ({
  warning: {
    backgroundColor: '#f9d563',
    padding: '.8rem 1rem',
  },
  button: {
    margin: '0 1rem',
  }
}));

const SessionGuard: React.FC<Props> = ({signOut, isLoggedIn, secondsRemaining, children}) => {
  const classes = useStyles();

  if (!isLoggedIn) {
    return <NotSignedIn />;
  } else if (secondsRemaining <= 10) {
    signOut();

    return (
      <>
        <Paper className={classes.warning}>
          Your session has expired. Please log in again.
        </Paper>
        <NotSignedIn />;
      </>
    );
  } else if (secondsRemaining <= 180) {
    return (
      <>
        <Paper className={classes.warning}>
          Your session will expire soon for security reasons. Please log in again.
          <Button
            className={classes.button}        
            variant='contained'
            color='primary'
            onClick={signOut}
          >
            I&apos;m ready to log in again
          </Button>
        </Paper>

        {children}
      </>
    );
  } else {
    return <>{children}</>;
  }
}
export default SessionGuard;
